import { render } from "./ssdetail.vue?vue&type=template&id=620f947b&scoped=true"
import script from "./ssdetail.vue?vue&type=script&lang=js"
export * from "./ssdetail.vue?vue&type=script&lang=js"

import "./ssdetail.vue?vue&type=style&index=0&id=620f947b&lang=scss&scoped=true"
import "./ssdetail.vue?vue&type=style&index=1&id=620f947b&lang=css"

import exportComponent from "D:\\workCode\\PC\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-620f947b"]])

export default __exports__